<template lang="pug">
  .chart-showcase
    .mx-12
      h2.acg-heading.d-inline {{title}}
        div(style="visibility:hidden").d-inline
          tooltip-btn(label="Refresh Insights" icon="mdi-refresh" tooltip-color="secondary" large @click="refreshShowcase")
        .caption Do you have a project using one of our datasets? Submit <a href="mailto:opendata@arlingtonva.us">here</a>. 
    v-slide-group(:show-arrows="$vuetify.breakpoint.smAndUp")
      v-slide-item(v-for="app in showcase")
          Appcard(
            :title = "app.title"
            :description = "app.description"
            :image = "app.image"
            :to = "app.url"
            :dataset = "app.dataset[0]"
            :collection_id = "app.collection_id"
            rows="1"
            show-nav
            hover-details
            style="width:400px"
          ).ma-1
</template>

<script>
import Appcard from "@/components/Appcard.vue";
import TooltipBtn from "@/components/TooltipBtn.vue";
import config from '@/config'

export default {
  props: ["title", "description"],
  data: () => ({
    showcase: Array
  }),
  components: {
    Appcard,
    TooltipBtn
  },
  mounted() {
    
    this.refreshShowcase()
  },
  methods: {
    async refreshShowcase() {
      let response = await fetch(`${config.strapiBase}/opendata-showcases`);
      this.showcase = await response.json()
      this.showcase.sort(() => Math.random() - 0.5)
        .slice(0, 5);
    },
  },
  computed: {}
};
</script>